import React from 'react';
import { CheckCircleIcon, TagIcon, StarIcon } from 'lucide-react';
interface SupplierCardProps {
  supplier: {
    id: string;
    name: string;
    description: string;
    tags: string[];
    rating: number;
    selected: boolean;
  };
  selected: boolean;
  onSelect: () => void;
}
const SupplierCard: React.FC<SupplierCardProps> = ({
  supplier,
  selected,
  onSelect
}) => {
  // Add console logging to debug selection state
  console.log(`SupplierCard rendering for ${supplier.name}:`, {
    id: supplier.id,
    cardSelected: selected,
    supplierSelected: supplier.selected
  });
  // Handle click on the entire card
  const handleCardClick = () => {
    console.log(`Card clicked for ${supplier.name}`);
    onSelect();
  };
  // Handle click on the checkmark specifically
  const handleCheckmarkClick = (e: React.MouseEvent) => {
    console.log(`Checkmark clicked for ${supplier.name}`);
    e.stopPropagation(); // Prevent triggering card click
    onSelect();
  };
  return <div className={`border rounded-lg p-4 cursor-pointer transition-colors ${selected ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-300'}`} onClick={handleCardClick} data-supplier-id={supplier.id} data-selected={selected} data-id="element-952">
      <div className="flex justify-between items-start" data-id="element-953">
        <div data-id="element-954">
          <h3 className="font-medium text-gray-900" data-id="element-955">{supplier.name}</h3>
          <p className="text-sm text-gray-600 mt-1" data-id="element-956">{supplier.description}</p>
          <div className="flex flex-wrap gap-1 mt-2" data-id="element-957">
            {supplier.tags.map((tag, index) => <span key={index} className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800" data-id="element-958">
                <TagIcon size={12} className="mr-1" data-id="element-959" />
                {tag}
              </span>)}
          </div>
        </div>
        <div className="flex items-center" data-id="element-960">
          <div className="flex items-center mr-2" data-id="element-961">
            <StarIcon size={16} className="text-yellow-400" data-id="element-962" />
            <span className="ml-1 text-sm font-medium" data-id="element-963">{supplier.rating}</span>
          </div>
          <button className={`h-6 w-6 rounded-full flex items-center justify-center ${selected ? 'bg-blue-500 text-white' : 'border border-gray-300'}`} onClick={handleCheckmarkClick} aria-label={selected ? 'Deselect supplier' : 'Select supplier'} data-id="element-964">
            {selected && <CheckCircleIcon size={16} data-id="element-965" />}
          </button>
        </div>
      </div>
    </div>;
};
export default SupplierCard;